export const SUBFORM_CUSTOMER = 'SUBFORM_CUSTOMER';
export const SUBFORM_PERSONA = 'SUBFORM_PERSONA';
export const SUBFORM_BILLING_ADDRESS = 'SUBFORM_BILLING_ADDRESS';
export const SUBFORM_SHIPPING_ADDRESS = 'SUBFORM_SHIPPING_ADDRESS';



// WEBPACK FOOTER //
// ./src/order/subforms/SubformsConstants.js